(function () {
  var NEW_TEXT = 'Trusted by 500,000+ Pet Parents';

  function setText() {
    var headings = document.querySelectorAll('.oke-reviewCarousel-header-title');
    headings.forEach(function (h2) {
      if (h2.textContent.trim() !== NEW_TEXT) {
        h2.textContent = NEW_TEXT;
      }
    });
  }

  function init() {
    setText(); // run once in case the widget is already rendered
    new MutationObserver(setText).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
